import type { TrainingType, MemberTrainingStatus } from './types';
import type { TrainingContentExtension, TrainingContentType } from './trainingContent.types';

export const TRAINING_TYPE_LABELS: Record<TrainingType, string> = {
  ONBOARDING: 'Onboarding',
  ROLE_CHANGE: 'Alteração de função',
  SGQ_DOCUMENT_FOCAL: 'Documento do SGQ | Pontual',
  SGQ_DOCUMENT_HOMOLOGATION: 'Documento do SGQ | Fluxo de Homologação',
  OPEN_TRAINING: 'Treinamento aberto',
};

// Documento SGQ - Pontual/Fluxo de Homologação e Treinamento Aberto seguem a redação exata do
// registro impresso RQ18.1 (sem o "do"), diferente dos rótulos genéricos usados em
// listagem/dropdown.
export const TRAINING_CONTROL_TYPE_LABELS: Record<TrainingType, string> = {
  ...TRAINING_TYPE_LABELS,
  SGQ_DOCUMENT_FOCAL: 'Documento SGQ - Pontual',
  SGQ_DOCUMENT_HOMOLOGATION: 'Documento SGQ - Fluxo de Homologação',
  OPEN_TRAINING: 'Treinamento Aberto',
};

export const TRAINING_TYPE_BADGES: Record<TrainingType, string[]> = {
  ONBOARDING: ['Onboarding'],
  ROLE_CHANGE: ['Alteração de função'],
  SGQ_DOCUMENT_FOCAL: ['Documento do SGQ', 'Pontual'],
  SGQ_DOCUMENT_HOMOLOGATION: ['Documento do SGQ', 'Fluxo de Homologação'],
  OPEN_TRAINING: ['Treinamento aberto'],
};

export const MEMBER_TRAINING_STATUS_LABELS: Record<MemberTrainingStatus, string> = {
  PENDING: 'Pendente',
  COMPLETED: 'Concluído',
  NOT_COMPLETED: 'Não concluído',
};

export const TRAINING_TYPE_OPTIONS: { value: TrainingType; label: string }[] = (
  Object.keys(TRAINING_TYPE_LABELS) as TrainingType[]
).map((value) => ({ value, label: TRAINING_TYPE_LABELS[value] }));

export const TRAINING_CONTENT_EXTENSION_LABELS: Record<TrainingContentExtension, string> = {
  FILE: 'Arquivo',
  VIDEO: 'Vídeo',
};

export const TRAINING_CONTENT_TYPE_LABELS: Record<TrainingContentType, string> = {
  SGQ: 'SGQ',
  FREE: 'Livre',
};

export const TRAINING_CONTENT_EXTENSION_OPTIONS: {
  value: TrainingContentExtension;
  label: string;
}[] = [
  { value: 'FILE', label: TRAINING_CONTENT_EXTENSION_LABELS.FILE },
  { value: 'VIDEO', label: TRAINING_CONTENT_EXTENSION_LABELS.VIDEO },
];

export const TRAINING_CONTENT_TYPE_OPTIONS: {
  value: TrainingContentType;
  label: string;
}[] = [
  { value: 'SGQ', label: TRAINING_CONTENT_TYPE_LABELS.SGQ },
  { value: 'FREE', label: TRAINING_CONTENT_TYPE_LABELS.FREE },
];

const MEGABYTE = 1024 * 1024;
const GIGABYTE = 1024 * MEGABYTE;

export const TRAINING_CONTENT_MAX_UPLOAD_SIZE_BYTES = 5 * GIGABYTE;

export const TRAINING_CONTENT_MAX_UPLOAD_SIZE_LABEL = '5 GB';

export const TRAINING_CONTENT_TITLE_MAX_LENGTH = 255;
export const TRAINING_CONTENT_URL_MAX_LENGTH = 2048;
export const TRAINING_CONTENT_MAX_VISIBILITY_IDS = 500;
